import { getActiveFilters } from "./formatting";

/**
 * Builds API request parameters with pagination
 * @param initialParams - Base parameters for the request
 * @param newPage - Page number to request (optional)
 * @param newPerPage - Number of items per page (optional)
 * @returns Record with all active filters and pagination parameters
 */
export const getParamsWithPagination = <T extends Record<string, unknown>>(
  initialParams: T,
  newPage?: number,
  newPerPage?: number
): Record<string, string | number | boolean> => {
  const params = getActiveFilters(initialParams);
  if (!newPage && !newPerPage) {
    return params;
  }

  if (newPerPage) {
    // Ensure per_page is a positive number and has a reasonable upper limit
    const validPerPage = Math.max(1, Math.min(newPerPage, 200));
    params.per_page = validPerPage;
  }
  if (newPage) {
    // Ensure page is at least 1
    const validPage = Math.max(1, newPage);
    params.page = validPage;
  }

  return params;
};
